module.exports = __webpack_public_path__ + "img/bg1.a77bd711.png";